import translating from './../translate.json';

const fields = () => {
  return [
    {
      name: 'textId',
      label: 'textId',
      readOnly: true
    },
    {
      name: 'text',
      label: translating.text,
      type: 'textarea'
    }
  ];
};

export default fields;
